import { Box } from "@chakra-ui/react";
import { createContext, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { StatusDotLabel } from "./StatusDotLabel";

const MissingAnswersContext = createContext(false);

export const MissingAnswersProvider = MissingAnswersContext.Provider;

export const useShowMissingAnswers = (): boolean => useContext(MissingAnswersContext);

export const MISSING_ITEM = { "data-missing-item": true } as const;

export const MissingAnswerMark = () => {
  const { t } = useTranslation();
  return (
    <Box as="span" data-missing-answer tabIndex={-1} flexShrink={0} _focus={{ outline: "none" }}>
      <StatusDotLabel variant="issue" label={t("Not answered")} />
    </Box>
  );
};

export const useJumpToFirstMissingAnswer = (show: boolean, step: string | null) => {
  useEffect(() => {
    if (!show) return;
    const frame = requestAnimationFrame(() => {
      const mark = document.querySelector<HTMLElement>("[data-missing-answer]");
      if (!mark) return;
      mark.scrollIntoView?.({ block: "center" });
      const field = mark.closest("[data-missing-item]")?.querySelector<HTMLElement>("input, textarea, button");
      (field ?? mark).focus({ preventScroll: true });
    });
    return () => cancelAnimationFrame(frame);
  }, [show, step]);
};
